<template>
  <div class="test" style="text-align:center;width:800px;margin-left:auto;margin-right:auto;">
    <img alt="Vue logo" src="@/assets/IOIHANlogo300x502.png">
    <hr>
    <br>
    <h1>Filter Test</h1>
    <!-- The width of the "real" ticket is responsive so testing with various sizes -->
    <label>Search</label>
    <input v-model="search" />
     <b-table :items="transactions" :fields="fields" :filter="search" >
     </b-table>
  </div>
</template>

<script>
// @ is an alias to /src
import FilterCard from "@/components/FilterCard.vue"

export default {
  name: "FilterTest",
  components: {
    
  },
  data() {
    return {
      search:"",
      fields: ['firstName', 'lastName', 'transactionDate','revenueCenter','tenderKey','total'],

      "transactions": [
        {
          "_id": "4IPMHMBDBVSDUK73",
          "firstName": "Sirena",
          "lastName": "Kohn",
          "transactionDate": "2020-06-05",
          "revenueCenter": 120,
          "tenderKey": 6,
          "email": "kris.thames0109@rug.com",
          "url": "http://www.sponsors.chikuma.nagano.jp",
          "description": "recommendations give passport par fighting not costs rating focused row sponsored excluding obligations weather responsibilities mobiles naughty enquiry unexpected relates",
          "verified": true,
          "total": 52767
        },
        {
          "_id": "XHVIHQCCPS3JZS49",
          "firstName": "Stephane",
          "lastName": "Ng",
          "transactionDate": "2020-03-16",
          "revenueCenter": 69,
          "tenderKey": 7,
          "email": "penney_loy183@nominations.capitalone",
          "url": "https://www.troops.com",
          "description": "attached avoid bonus routine columbus effects decor lots gave mental gifts accepting nn stockholm resource cable serious ace danish browser",
          "verified": true,
          "total": 27793
        },
        {
          "_id": "LK83PDDZ9OE5FKM7",
          "firstName": "Kimberely",
          "lastName": "Fierro",
          "transactionDate": "2017-04-30",
          "revenueCenter": 123,
          "tenderKey": 9,
          "email": "kristeen1@yahoo.com",
          "url": "https://mounting.com",
          "description": "industry surgeons disturbed carlos aj tulsa nickel cloudy some song handmade sofa prep decide le scholars nav investigation stability forty",
          "verified": false,
          "total": 11988
        },
        {
          "_id": "51PJLQJE297VIDBQ",
          "firstName": "Xiao",
          "lastName": "Lincoln",
          "transactionDate": "2017-05-10",
          "revenueCenter": 25,
          "tenderKey": 7,
          "email": "florene-rendon9749@trinity.com",
          "url": "https://rentals.com",
          "description": "murder eau vitamin slovak receives position bread appendix prot toe katrina manufacturing parameters note electronic acid yard counted centered mystery",
          "verified": true,
          "total": 68237
        },
        {
          "_id": "VORJCZD54JJTQCA5",
          "firstName": "Leoma",
          "lastName": "Christenson",
          "transactionDate": "2016-09-05",
          "revenueCenter": 135,
          "tenderKey": 6,
          "email": "donnetta-houston5440@yahoo.com",
          "url": "https://nails.mo-i-rana.no",
          "description": "aging punishment villages factory deny explore technical rest marketplace volt prairie charleston features cooking objects dairy endless archived icq cooler",
          "verified": true,
          "total": 56145
        },
        {
          "_id": "FNDMK020FID5D2S5",
          "firstName": "Theodora",
          "lastName": "Comstock",
          "transactionDate": "2015-01-28",
          "revenueCenter": 173,
          "tenderKey": 5,
          "email": "kendall_bates@yahoo.com",
          "url": "http://www.boxing.com",
          "description": "worship barriers recover louisiana advisory angeles er tall html possible sprint obituaries avoid camcorder xl opposed everything italy ng millions",
          "verified": false,
          "total": 65758
        },
        {
          "_id": "828SANIKZVTDQYM0",
          "firstName": "Sheree",
          "lastName": "Hay",
          "transactionDate": "2021-02-08",
          "revenueCenter": 179,
          "tenderKey": 8,
          "email": "vashtigutierrez48419@generating.bømlo.no",
          "url": "http://www.embassy.com",
          "description": "specify shops attract ids vital um foundations muslims diagnostic allergy jean young settlement admitted rouge gratis wit experienced handling ron",
          "verified": true,
          "total": 60019
        },
        {
          "_id": "A738076T2TAAOJF7",
          "firstName": "Dorethea",
          "lastName": "Ash",
          "transactionDate": "2019-10-27",
          "revenueCenter": 94,
          "tenderKey": 6,
          "email": "nichole.pellegrino@gmail.com",
          "url": "http://harmful.com",
          "description": "latest preferred saw despite palm bored workshops cemetery reflect ch congressional cal idol developed features footage ist disappointed seq served",
          "verified": false,
          "total": 25924
        },
        {
          "_id": "2YJUJYR8BJ7LTV5P",
          "firstName": "Sol",
          "lastName": "Shephard",
          "transactionDate": "2020-07-30",
          "revenueCenter": 171,
          "tenderKey": 7,
          "email": "cinthia-muir@lined.com",
          "url": "http://advisory.is-gone.com",
          "description": "weights simpson tropical samsung mission ballot frank councils baking framed renewable mens licence conditions karaoke shades philip rapids third marcus",
          "verified": true,
          "total": 61492
        },
        {
          "_id": "1CL319B735FJMLQ0",
          "firstName": "Genesis",
          "lastName": "Ward",
          "transactionDate": "2015-11-06",
          "revenueCenter": 121,
          "tenderKey": 6,
          "email": "marine19@yahoo.com",
          "url": "https://www.stood.com",
          "description": "make article leadership pointed mature contacted operating winston lp queen pd moore appliance respective cornell guild isolation recommendations combined wood",
          "verified": false,
          "total": 53719
        },
        {
          "_id": "IS18QD7AQ2ROQSU9",
          "firstName": "Sunday",
          "lastName": "Mena",
          "transactionDate": "2020-11-15",
          "revenueCenter": 71,
          "tenderKey": 2,
          "email": "annwoodworth76@hotmail.com",
          "url": "https://www.gain.com",
          "description": "attacked describes lying glad cheat museum fairfield regarded samba correction zoning moisture functioning acres the purchases pens subscriber lands anyone",
          "verified": true,
          "total": 23258
        },
        {
          "_id": "R7AZQXGCZDD7XSHG",
          "firstName": "Amber",
          "lastName": "Burrows",
          "transactionDate": "2014-03-04",
          "revenueCenter": 127,
          "tenderKey": 1,
          "email": "marine_arriola@valuable.com",
          "url": "https://hydraulic.com",
          "description": "sr voyeurweb groove poultry volvo defense featuring height renew sas selling difficult furthermore techniques etc usa tracy herb instant nebraska",
          "verified": true,
          "total": 65427
        },
        {
          "_id": "LE5B2KHMDLJ30QQK",
          "firstName": "Eliz",
          "lastName": "Armenta",
          "transactionDate": "2019-12-16",
          "revenueCenter": 54,
          "tenderKey": 2,
          "email": "hermelinda_kraft26@ourselves.com",
          "url": "http://knitting.com",
          "description": "suspended assists bi greene training lightbox reflected follow pichunter glossary kde surf ap works faced mins circulation healthcare register dame",
          "verified": true,
          "total": 17000
        },
        {
          "_id": "8E6Z3CQ7IPATTM45",
          "firstName": "Fran",
          "lastName": "Mckay",
          "transactionDate": "2018-04-18",
          "revenueCenter": 105,
          "tenderKey": 4,
          "email": "micheline.blackmon85@crucial.com",
          "url": "https://novel.com",
          "description": "jewish equilibrium gore pass freeze our users marathon clicks eng effectively insurance trades eds curious battlefield henry barcelona hk depression",
          "verified": true,
          "total": 31085
        },
        {
          "_id": "U64R5D0P11I2A6AJ",
          "firstName": "Sanford",
          "lastName": "Straub",
          "transactionDate": "2016-01-06",
          "revenueCenter": 197,
          "tenderKey": 7,
          "email": "wes4@gis.com",
          "url": "http://origins.com",
          "description": "dealtime english marshall oclc trinity carpet near espn jackie tries midnight running shipped sheffield beta reveal officials bibliographic purple challenged",
          "verified": true,
          "total": 51141
        },
        {
          "_id": "23B7QNN983YACYPQ",
          "firstName": "Merle",
          "lastName": "Marion",
          "transactionDate": "2014-05-02",
          "revenueCenter": 34,
          "tenderKey": 9,
          "email": "christanava182@gmail.com",
          "url": "https://www.representations.com",
          "description": "jr daily ladder columns compete dialogue formal mu colour monica fleet literally sa illustrations thirty failure proven illness airfare dist",
          "verified": true,
          "total": 66709
        },
        {
          "_id": "D7SN3LZRF5I2353Y",
          "firstName": "Herta",
          "lastName": "Burney",
          "transactionDate": "2017-11-22",
          "revenueCenter": 22,
          "tenderKey": 8,
          "email": "jefferey-rainey-kaminski@dogs.carrier.museum",
          "url": "http://www.way.com",
          "description": "pike dialogue invoice publishing areas documentary currently streams makers rpg jp mating eh snap rod mistakes remarkable plastic rio opera",
          "verified": true,
          "total": 14479
        },
        {
          "_id": "G2Y0K7EPSXM1LK3Q",
          "firstName": "Palma",
          "lastName": "Francois",
          "transactionDate": "2019-05-13",
          "revenueCenter": 175,
          "tenderKey": 7,
          "email": "jamemcleod378@gmail.com",
          "url": "http://rome.com",
          "description": "amend dame fair harassment top play hacker consist bidder treating egyptian past desire something sheffield musical heritage mu framed sku",
          "verified": false,
          "total": 47150
        },
        {
          "_id": "DUCHUV9RJN9I0U51",
          "firstName": "Nelda",
          "lastName": "Moser",
          "transactionDate": "2014-02-28",
          "revenueCenter": 68,
          "tenderKey": 2,
          "email": "jimmie_castellanos@hotmail.com",
          "url": "http://calgary.com",
          "description": "edgar validation login thereby needle dividend forum pill tower stays http amber forgot parameter fat hall minute shut mn aspect",
          "verified": false,
          "total": 54763
        },
        {
          "_id": "HJX4XBFLSSAMZQSM",
          "firstName": "Wendell",
          "lastName": "Higdon",
          "transactionDate": "2016-08-14",
          "revenueCenter": 62,
          "tenderKey": 9,
          "email": "dortheyashworth5@russian.com",
          "url": "https://brochures.md.us",
          "description": "permission kitty trackback screensavers upc exist lobby fri jay newer removed nickel scared trek documentary undefined bio kitty highly isolated",
          "verified": false,
          "total": 59618
        }
      ]
     
    }
  },
  created() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    filter() {

    },
    filterdList() {
      return this.transactions.filter(t => {
        return t.revenueCenter === 6;
      })
    }
  }
}
</script>
<style lang="scss">

</style>